import SubInfo from './SubInfo.component';

export default SubInfo;